import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { Button, Col, Container, Row, Card, Form } from "react-bootstrap";
import { useState, useContext } from "react";
import { useLocation } from "react-router-dom";
import { Context } from "context/AuthContext";
import { useNavigate } from "react-router-dom";
import logo from "assets/imgs/Logo-Principal-Brancopng.png";
import { POST_NOVA_SENHA } from "../../../../services/Usuario";

import "../../../RedefinirSenha/styles.scss";

const ContentNewPassword = (props) => {
  const params = new URLSearchParams(useLocation().search);
  const { showLoader } = useContext(Context);
  const navigate = useNavigate();

  const initialState = {
    userid: params.get("user"),
    token: params.get("token"),
    novasenha: "",
    confirmacaosenha: "",
  };

  const [values, setValues] = useState(initialState);
  const [errors, setErrors] = useState({});

  function onChange(event) {
    const { value, name } = event.target;
    setValues({
      ...values,
      [name]: value,
    });
  }

  async function onSubmit(event) {
    event.preventDefault();
    const response = validate();

    if (Object.keys(response).length > 0) {
      return;
    }

    showLoader(true);
    setErrors({});
    const result = await POST_NOVA_SENHA(values);
    showLoader(false);

    if (result && result.errors && result.errors.length > 0) {
      setErrors(result.errors);
    } else {
      navigate("/senha-alterada");
    }
  }

  const validate = () => {
    let errors = {};

    if (!values.novasenha) {
      errors.novasenha = "O campo senha é obrigatório";
    }

    if (!values.confirmacaosenha) {
      errors.confirmacaosenha = "O campo confirmação de senha é obrigatório";
    }

    if (values.novasenha !== values.confirmacaosenha) {
      errors.confirmacaosenha = "As senhas não conferem";
    }

    setErrors(errors);
    return errors;
  };

  return (
    <div className="content-wrapper">
      <Container>
        <Row className="vh-100 d-flex  justify-content-center align-items-center content-redefinir-senha">
          <Col md={8} lg={10} xs={12}>
            <Card className="shadow">
              <Row className="g-0 h-100">
                <Col md={4} className="column-img-redefinir-senha ">
                  <img
                    src={logo}
                    alt="Imagem de registro"
                    className="img-fluid card-img"
                  />
                </Col>
                <Col md={8}>
                  <Card.Body className="h-100 d-flex flex-column m-3">
                    <div className="mb-3 mt-4">
                      <h3 className="fw-bold  mb-2">Redefinir senha</h3>
                      <p className="mb-5">
                        Cadastre abaixo uma nova senha de acesso para a sua
                        conta. <br></br>
                        Dica: Escolha uma senha segura e de fácil memorização.
                      </p>
                      <Form
                        className="flex-grow-1 d-flex flex-column justify-content-between"
                        onSubmit={onSubmit}
                      >
                        <div>
                          <Row className="mb-3">
                            <Form.Group
                              as={Col}
                              xs={12}
                              md={6}
                              className="mb-3"
                              controlId="formBasicPassword"
                            >
                              <Form.Label>Senha</Form.Label>
                              <Form.Control
                                name="novasenha"
                                type="password"
                                placeholder="Nova senha"
                                onChange={onChange}
                                isInvalid={!!errors.novasenha}
                              />
                              <Form.Control.Feedback type="invalid">
                                {errors.novasenha}
                              </Form.Control.Feedback>
                            </Form.Group>
                            <Form.Group
                              as={Col}
                              className="mb-3"
                              controlId="formConfirmPassword"
                            >
                              <Form.Label>Confirme sua senha</Form.Label>
                              <Form.Control
                                name="confirmacaosenha"
                                type="password"
                                placeholder="Confirme sua senha"
                                onChange={onChange}
                                isInvalid={!!errors.confirmacaosenha}
                              />
                              <Form.Control.Feedback type="invalid">
                                {errors.confirmacaosenha}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Row>
                        </div>

                        <div className="d-flex justify-content-between gap-3">
                          <Button
                            variant="primary"
                            type="button"
                            onClick={() => navigate("/login")}
                          >
                            <FontAwesomeIcon icon={faArrowLeft} /> Voltar
                          </Button>
                          <Button variant="primary" type="submit">
                            Enviar
                          </Button>
                        </div>
                      </Form>
                    </div>
                  </Card.Body>
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ContentNewPassword;
